import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContactsFilters from "src/features/contacts/ContactsFilters";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import BaseHeader from "src/pages/layout/Header";
const Header = () => {
    return (_jsxs(BaseHeader, { className: 'conversations-header', children: [_jsx(PageNavBreadcrumbs, {}), _jsx(ContactsFilters, {})] }));
};
export default Header;
